if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;
        this.keyupHandler = (e) => {
          if (e.key === 'Escape') {
            this.closePopover(e);
          }
        };
        this.closePopoverHandler = this.closePopover.bind(this);
        this.togglePopoverHandler = this.togglePopover.bind(this);

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopoverHandler);
        }

        if (this.popoverInfo && this.infoButtonDesktop) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopoverHandler);
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopoverHandler);
          this.infoButtonDesktop.addEventListener('focusout', this.closePopoverHandler);
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopoverHandler);
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopoverHandler);
          this.infoButtonDesktop.addEventListener('keyup', this.keyupHandler);
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopoverHandler);
          this.infoButtonMobile.addEventListener('keyup', this.keyupHandler);
        }
      }

      disconnectedCallback() {
        if (this.closeButton) {
          this.closeButton.removeEventListener('click', this.closePopoverHandler);
        }

        if (this.popoverInfo && this.infoButtonDesktop) {
          this.popoverInfo.removeEventListener('mouseleave', this.closePopoverHandler);
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.removeEventListener('click', this.togglePopoverHandler);
          this.infoButtonDesktop.removeEventListener('focusout', this.closePopoverHandler);
          this.infoButtonDesktop.removeEventListener('mouseenter', this.togglePopoverHandler);
          this.infoButtonDesktop.removeEventListener('mouseleave', this.closePopoverHandler);
          this.infoButtonDesktop.removeEventListener('keyup', this.keyupHandler);
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.removeEventListener('click', this.togglePopoverHandler);
          this.infoButtonMobile.removeEventListener('keyup', this.keyupHandler);
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop ? this.infoButtonDesktop : this.infoButtonMobile;
        if (!button || !this.popoverInfo) return;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((!isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', String(!isExpanded));

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop?.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event?.preventDefault?.();
        const desktopButton = this.infoButtonDesktop;
        const popoverInfo = this.popoverInfo;
        const relatedTarget = event?.relatedTarget || null;
        const isButtonChild = desktopButton ? desktopButton.contains(relatedTarget) : false;
        const isPopoverChild = popoverInfo ? popoverInfo.contains(relatedTarget) : false;

        const button = desktopButton ? desktopButton : this.infoButtonMobile;
        if (!button || !popoverInfo) return;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          popoverInfo.setAttribute('hidden', '');
          desktopButton?.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}
